(function(){
  var nav=document.getElementById('kkgg-nav'),btn=document.getElementById('kkgg-float'),end=document.getElementById('kkgg-price');
  if(!nav){return;}
  function stuck(){
    var m=0;
    [[window.innerWidth/2,2],[12,2],[window.innerWidth-12,2]].forEach(function(pt){
      var el=document.elementFromPoint(pt[0],pt[1]);
      while(el&&el!==document.body&&el!==document.documentElement){
        if(el.id!=='kkgg-float'){var p=getComputedStyle(el).position;if(p==='fixed'||p==='sticky'){var r=el.getBoundingClientRect();if(r.top<=2&&r.bottom<window.innerHeight/2){m=Math.max(m,r.bottom);}}}
        el=el.parentElement;
      }
    });
    return m;
  }
  var base=0;
  function measure(){base=Math.max(base,stuck());}
  measure();window.addEventListener('load',measure);
  function target(){return Math.max(0,nav.getBoundingClientRect().top+window.pageYOffset-Math.max(base,stuck())-16);}
  function go(ev){
    if(ev){ev.preventDefault();}
    window.scrollTo({top:target(),behavior:'smooth'});
    var fix=function(){var t=target();if(Math.abs(window.pageYOffset-t)>8){window.scrollTo({top:t,behavior:'auto'});}};
    setTimeout(fix,900);
    nav.setAttribute('tabindex','-1');
    try{nav.focus({preventScroll:true});}catch(e){}
    nav.classList.remove('is-pulse');void nav.offsetWidth;nav.classList.add('is-pulse');
    setTimeout(function(){nav.classList.remove('is-pulse');},2400);
    if(history.replaceState){history.replaceState(null,'','#kkgg-nav');}
  }
  document.querySelectorAll('a[href="#kkgg-nav"]').forEach(function(a){a.addEventListener('click',go);});
  if(!btn||!('IntersectionObserver' in window)){return;}
  var navOut=false,atEnd=false;
  function upd(){btn.classList.toggle('is-on',navOut&&!atEnd);}
  new IntersectionObserver(function(e){navOut=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;upd();}).observe(nav);
  if(end){new IntersectionObserver(function(e){atEnd=e[0].isIntersecting||e[0].boundingClientRect.top<0;upd();}).observe(end);}
})();